export default __webpack_public_path__ + "static/media/envelope-regular.b61a2f18.svg";